import {io} from "socket.io-client";

// @ts-ignore
export const socket = io(import.meta.env.VITE_WS_SERVER_URL, {
    autoConnect: false,
    reconnection: false,
    withCredentials: true,
})